// @flow
import * as React from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import navigationStructure from '../NavigationStructure.js';
import "../css/Summary.css";
import type { AppStateType, HeadlineType, DataType } from '../Types';
import helpers from '../util/helpers';

// DetectionsTable.js

type DetectionsTableProps = {
    thedetections: DataType[],
    iswatertable: boolean,
    thispage: SummaryPage
}

class DetectionsTable extends React.Component<DetectionsTableProps> {
  //
  // props: thedetections, iswatertable, thispage
  //

  // WAS mydetectionsDisplayDoit(thedetections: DataType[], iswatergroup: boolean)

  render() {
    /* should we show the visit column?  if water... no */
    let showvisit = true; 
    let visitHTMLheader = null; //JSX whitespace
    if (1) 
    {
      // let iswatergroup = this.waterpage(); // make it an INPUT
      if (this.props.iswatertable) showvisit = false;
      if (showvisit) visitHTMLheader = <th><FormattedMessage id='your_results.visit' /></th>
    }

    const mydetectionsDisplayHead = 
              <tr>
                <th><FormattedMessage id='your_results.chemical' /></th>
                <th><FormattedMessage id='your_results.measurement' /></th>
                {visitHTMLheader}
                <th><FormattedMessage id='your_results.group' /></th>
              </tr>

    // const thedetections = this.mydetections();// make it an INPUT

    let filtered_detections = this.props.thedetections;    
    filtered_detections =  this.mydetectionsFiltered(filtered_detections, this.props.iswatertable);

    const mydetectionsDisplayRows = filtered_detections.map( (x, i) => { return this.mydetectionsDisplayDoit_row(x, i, showvisit); } );

    return (
        <table className='table mydetections-table'>
            <thead>
              {mydetectionsDisplayHead}
            </thead>
            <tbody>
              {mydetectionsDisplayRows}
            </tbody>
        </table>
    );
  } // END render (WAS mydetectionsDisplayDoit)

  watergroup(groupkey): boolean {
    // perhaps better than looking at the page URL so a mixed results page is possible
    return (groupkey.search(/water/i) >= 0)
  }

  mydetectionsDisplayDoit_nameANDabbr(detection: DataType) {
    let result = `${detection.chemical_full} (${detection.chemical})`;
    if (detection.chemical_full === detection.chemical) {
      result= detection.chemical_full; // e.g. parabens have no abbreviation
    }
    return result;
  }

  mydetectionsDisplayDoit_row(detection: DataType, i: integer, showvisit: boolean)
  {
    let thispage = this.props.thispage; // WAS this
    let detectiongroupkey = helpers.convertGroupName(detection.group);
    let thegroup = thispage.props.intl.messages['chemicals.'+detectiongroupkey+'.title']; // .title in ES or EN.  .data is in EN always and is group name - capitalized and space instead of _ except for sunscreen
    
    let groupurl = Object.keys(navigationStructure).filter(function(key) {return navigationStructure[key].group === detectiongroupkey})[0];

    let iswatergroup = this.watergroup(detectiongroupkey);
    let inmedium;
    if (iswatergroup)
      inmedium = " "+thispage.props.intl.messages['in_water'];  //XXX medium would ideally be in detections.csv
    else
      inmedium = " "+thispage.props.intl.messages['in_urine'];  //XXX medium
    
    // conditional 1
    let thevalue = detection.value + "  μg/L" +inmedium; // XXX: units
    if (!detection.detected) thevalue = thispage.props.intl.messages['not_detected'] + inmedium;  

    // conditional 2
    let visitHTML = null; //JSX whitespace
    if (showvisit) 
    {
      let thevisit = ""
      if (detection.visit) thevisit =  detection.visit; // thispage.props.intl.messages['your_level_visit'] + "#" +    e.g. Visit#3
      visitHTML = <td>{thevisit}</td>;
    }

 //  <a href="#" onClick={(e) => thispage.goto(e, groupurl)}>{thegroup}</a>

    let thename = this.mydetectionsDisplayDoit_nameANDabbr(detection);

    return (
      <tr key={i}>
        <td>{thename}</td><td>{thevalue}</td>{visitHTML}<td>{thegroup}</td>
      </tr>
    )
  } // END mydetectionsDisplayDoit_row  


  mydetections1_waterFilterFunction(d: DataType | HeadlineType): boolean {
    // "this": value of the optional argument to a JS filter function, send true or false
    let ispagewater = this;
    let isdatawater = (d.group === "Water CVOCs" || d.group === "Water Phthalates")
    if (ispagewater === true) 
      return isdatawater;
    else
      return !isdatawater;
  }

  mydetections1_Compare(a: DataType, b: DataType): number {
    let x = a.chemical_full + a.visit;
    let y = b.chemical_full + b.visit;
    return ((x < y) ? -1 : ((x > y) ? 1 : 0));
  }

  mydetectionsFiltered(thedata: DataType[], wantwaterYN: boolean):  DataType[] {
    // let wantwaterYN = this.waterpage();
    // let thedata = this.props.appState.data;
    return thedata
      .filter((d) => d.mine === true)
      .filter(this.mydetections1_waterFilterFunction, wantwaterYN)
      .sort(this.mydetections1_Compare)
  }

} // END Class DetectionsTable

export default DetectionsTable;


// WEBPACK FOOTER //
// ./src/components/DetectionsTable.js